import { Icon, IconSize, IconDisplay } from "@components/Icon";
import { ContactUsLink } from "@components/Link";
import styled from "@emotion/styled";
import React from "react";

import { SHARED_PALETTE } from "@every.org/common/src/display/palette";

import { horizontalStackCss } from "src/theme/spacing";

interface SubmitErrorMessageProps {
  "data-tname"?: string;
  error?: string;
  className?: string;
}

const MessageContainer = styled.div`
  ${horizontalStackCss.xs}
  color: ${SHARED_PALETTE.error};
  align-items: center;
  a {
    color: ${SHARED_PALETTE.error};
  }
`;

const Message = styled.span`
  color: ${SHARED_PALETTE.error};
`;

export const SubmitErrorMessage: React.FCC<SubmitErrorMessageProps> = ({
  error,
  ...rest
}) => {
  const renderErrorMessage = (text: string) => {
    const parts = text.split(/(contact us)/i);

    return parts.map((part) => {
      if (part.toLowerCase() === "contact us") {
        return <ContactUsLink key={part} />;
      }
      return part;
    });
  };

  return error ? (
    <MessageContainer {...rest}>
      <Icon
        iconImport={() => import("@components/Icon/icons/XIcon")}
        size={IconSize.MEDIUM}
        display={IconDisplay.ERROR}
      />
      <Message>{renderErrorMessage(error)}</Message>
    </MessageContainer>
  ) : null;
};
